/**
 * Business day calculation utilities for appointment scheduling
 */

export const getNextBusinessDay = (date: Date): Date => {
  const nextDay = new Date(date);
  nextDay.setDate(nextDay.getDate() + 1);
  
  // If it's Saturday (6) or Sunday (0), move to Monday
  while (nextDay.getDay() === 0 || nextDay.getDay() === 6) {
    nextDay.setDate(nextDay.getDate() + 1);
  }
  
  return nextDay;
};

export const getCurrentBusinessDay = (date: Date): Date => {
  const currentDay = new Date(date);
  
  // If it's Saturday (6) or Sunday (0), move to Monday
  while (currentDay.getDay() === 0 || currentDay.getDay() === 6) {
    currentDay.setDate(currentDay.getDate() + 1);
  }
  
  return currentDay;
};

export const getDefaultAppointmentDate = (): string => {
  const now = new Date();
  const currentHour = now.getHours();
  
  // If it's before 4 PM (16:00), use current business day
  // Otherwise, use next business day
  const targetDate = currentHour < 16 
    ? getCurrentBusinessDay(now)
    : getNextBusinessDay(now);
  
  return targetDate.toISOString().split('T')[0];
};

export const getDefaultAppointmentTime = (): string => {
  const now = new Date();
  const currentHour = now.getHours();
  
  // If it's before 4 PM (16:00), default to 4 PM
  // Otherwise, default to 10 AM
  return currentHour < 16 ? '16:00' : '10:00';
};